import { createAlertsManager } from '@bigcommerce/big-design'

export const d5AlertsManager: ReturnType<typeof createAlertsManager> =
  createAlertsManager()

export const D5Message = {
  success: (msg: string) => {
    d5AlertsManager.add({
      header: 'Success',
      messages: [
        {
          text: msg,
        },
      ],
      type: 'success',
      onClose: () => null,
      autoDismiss: true,
    })
  },
  error: (msg: string) => {
    d5AlertsManager.add({
      header: 'Failed',
      messages: [
        {
          text: msg,
        },
      ],
      type: 'error',
      onClose: () => null,
      autoDismiss: true,
    })
  },
  warning: (msg: string) => {
    d5AlertsManager.add({
      header: 'Warning',
      messages: [
        {
          text: msg,
        },
      ],
      type: 'warning',
      onClose: () => null,
      autoDismiss: true,
    })
  },
}
